import React from 'react';

import PropTypes from 'prop-types';
import { faEllipsis } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu as ShadcnDropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const DropdownMenu = ({
  disableMoveLeft,
  disableMoveRight,
  onDeleteStatusClick,
  onEditStatusClick,
  onMoveLeftClick,
  onMoveRightClick,
  onNewTaskClick,
}) => (
  <ShadcnDropdownMenu>
    <DropdownMenuTrigger asChild>
      {/* TODO: Should this be converted to size="sm"? */}
      <Button className="h-6 w-6 hover:bg-hover" variant="ghost">
        <FontAwesomeIcon className="text-muted-foreground" icon={faEllipsis} />
      </Button>
    </DropdownMenuTrigger>

    <DropdownMenuContent align="end">
      <DropdownMenuItem onClick={onNewTaskClick}>Add task</DropdownMenuItem>
      <DropdownMenuItem onClick={onEditStatusClick}>Update status name</DropdownMenuItem>

      <DropdownMenuItem disabled={disableMoveLeft} onClick={onMoveLeftClick}>
        Move status left
      </DropdownMenuItem>

      <DropdownMenuItem disabled={disableMoveRight} onClick={onMoveRightClick}>
        Move status right
      </DropdownMenuItem>

      <DropdownMenuSeparator />

      <DropdownMenuItem onClick={onDeleteStatusClick} variant="destructive">
        Delete status
      </DropdownMenuItem>
    </DropdownMenuContent>
  </ShadcnDropdownMenu>
);

DropdownMenu.propTypes = {
  disableMoveLeft: PropTypes.bool.isRequired,
  disableMoveRight: PropTypes.bool.isRequired,
  onDeleteStatusClick: PropTypes.func.isRequired,
  onEditStatusClick: PropTypes.func.isRequired,
  onMoveLeftClick: PropTypes.func.isRequired,
  onMoveRightClick: PropTypes.func.isRequired,
  onNewTaskClick: PropTypes.func.isRequired,
};

export default DropdownMenu;
